<template lang="pug">
transition(name='fade')
  .panel.panel-default(class='sortHandle')
    .panel-heading(role='tab' :id='`ac-header-` + item.id')
      .row
        .col-xs-1.icon
          // とりあえず取り扱う項目のタイプはこれだけある
          i.fa.fa-item.fa-header(aria-hidden='true' v-show='item.type === "title"')
          i.fa.fa-item.fa-font(aria-hidden='true' v-show='item.type === "text" || item.type === "name"')
          i.fa.fa-item.fa-align-justify(aria-hidden='true' v-show='item.type === "textarea"')
          i.fa.fa-item.fa-chevron-circle-down(aria-hidden='true' v-show='item.type === "dropdown"')
          i.fa.fa-item.fa-check-square-o(aria-hidden='true' v-show='item.type === "checkbox"')
          i.fa.fa-item.fa-dot-circle-o(aria-hidden='true' v-show='item.type === "radio"')
          i.fa.fa-item.fa-home(aria-hidden='true' v-show='item.type === "address"')
          i.fa.fa-item.fa-calendar(aria-hidden='true' v-show='item.type === "date"')
          i.fa.fa-item.fa-clipboard(aria-hidden='true' v-show='item.type === "file"')
          i.fa.fa-item.fa-envelope(aria-hidden='true' v-show='item.type === "mail"')
        // アコーディオンは自動生成したIDを使う
        .col-xs-11.title(aria-controls='collapseOne' data-toggle='collapse' data-parent='#accordion' :href='`#` + item.id') {{ !item.caption ? '項目名を入力してください' : item.caption }}
    // アコーディオンのターゲット
    .panel-collapse.collapse(:id='item.id' class='list-complete-item' role='tabpanel')
      .panel-body
        form
          table.form-table
            tr
              th
                label 項目名
              td
                input.form-control(type='text', placeholder='項目名を入力してください' v-model='item.caption')
            tr
              th
                label 必須項目
              td
                // requiredFixedにて必須のチェックボックスを制御可能。デフォルトはPartConfigを参照
                i.fa.fa-item.fa-check-square-o(aria-hidden='true' v-show='item.requiredFixed === true')
                input(type='checkbox' v-model='item.required' :checked='item.required === true' v-show='item.requiredFixed === false')
            // これは件名の場合だけ入力可能
            tr(v-show='item.type === `title`')
              th
                label 件名入力方法
              td
                label
                  input(type='radio' v-model='item.titleType' value='free')
                  | フリー入力
                label(style='margin-left: 10px')
                  input(type='radio' v-model='item.titleType' value='select')
                  | 選択式
            tr(v-show='showSelect')
              th
                label 選択候補
              td
                textarea.form-control(v-model='item.options' rows='5' placeholder='項目1\n項目2\n項目3\nのように改行区切りで入力してください')
                label(v-show="isOptionsFirstEmpty" style='margin: 5px 0px 0px 5px')
                  input(type='checkbox' v-model='item.optionsFirstEmpty' :checked='item.optionsFirstEmpty === true')
                  | 空の項目を先頭にする
            tr(v-show='showDirection')
              th
                label 配置方向
              td
                label
                  input(type='radio' v-model='item.direction' value='horizontal')
                  | 横
                label(style='margin-left: 10px')
                  input(type='radio' v-model='item.direction' value='vertical')
                  | 縦
            tr(v-show='item.type === `date`')
              th
                label 日付入力種類
              td
                label
                  input(type='radio' v-model='item.daySelectType' value='single')
                  | 日付(yyyy/mm/ddを入力します)
                label
                  input(type='radio' v-model='item.daySelectType' value='multi')
                  | 期間(yyyy/mm/dd ～ yyyy/mm/ddを入力します)
            tr(v-show='item.type === `textarea`')
              th
                label 初期行数
              td
                select.searchselect.selectitems(v-model='item.defaultLine'
                  data-toggle='tooltip' data-placement='top' title='入力行数を制限するものではございません')
                  option(value=5) 5
                  option(value=6) 6
                  option(value=7) 7
                  option(value=8) 8
                  option(value=9) 9
                  option(value=10) 10
            tr(v-show='showPlaceHolder')
              th
                label プレースホルダー
              td
                input.form-control.placeholderinput(type='text' v-model='item.placeholder'
                  placeholder='入力のヒント' data-toggle='tooltip' data-placement='top' title='ヒントを示してユーザーの入力を補助するものです')
            tr
              th
                label 補足説明
              td
                textarea.form-control(v-model='item.description' rows='3' placeholder='入力項目の補足説明を記載できます')
            tr(v-show='showWidth')
              th
                label 幅指定
              td
                input.form-control(v-model='item.width' type='number' name='size' min='1' style='text-align: right; display: inline; width: 25%')
                span(style='margin-left: 5px') px
            //- tr(v-show='item.type === `file`')
            //-   th
            //-     label ファイル形式
            //-   td
            //-     textarea.form-control(v-model='item.fileTypes' rows='5' placeholder='jpg\ngif\npng\nのように改行区切りで入力してください')
        p
          button.btn.btn-danger(@click='remove' v-show='item.deletable') 削除
</template>

<script>

export default {
  props: ['data'],
  data () {
    return {
      item: this.data
    }
  },
  methods: {
    remove () {
      let message = 'この項目をフォームから削除します。よろしいですか？'
      if (confirm(message)) {
        this.$emit('remove')
      }
    }
  },
  computed: {
    showSelect () {
      return ['dropdown', 'radio', 'checkbox', ['title', 'select']]
        .some((item) => {
          return item === this.item.type ||
            (Array.isArray(item) && this.item.type === item[0] && this.item.titleType === item[1])
        })
    },
    showDirection () {
      let selectType = ['radio', 'checkbox']
      return selectType.some((type) => { return type === this.item.type })
    },
    showPlaceHolder () {
      return ['name', ['title', 'free'], 'text', 'name', 'textarea']
        .some((item) => {
          return item === this.item.type ||
            (Array.isArray(item) && this.item.type === item[0] && this.item.titleType === item[1])
        })
    },
    showWidth () {
      return ['name', ['title', 'free'], 'mail', 'text', 'name', 'textarea']
        .some((item) => {
          return item === this.item.type ||
            (Array.isArray(item) && this.item.type === item[0] && this.item.titleType === item[1])
        })
    },
    isOptionsFirstEmpty () {
      return [['title', 'select'], 'dropdown']
        .some((item) => {
          return item === this.item.type ||
            (Array.isArray(item) && this.item.type === item[0] && this.item.titleType === item[1])
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
input, select
  vertical-align: middle

input[type=radio], input[type=checkbox]
  margin: 0px 5px 0px 0px

.panel-heading
  background-image: none
  background-color: #fff !important
  .icon
    padding-left: 15px
  .title
    color: #73879C
    background-color: white
    font-size: 16px
    font-weight: bold
    padding: 5px 15px
    height: 100%
    cursor: pointer
    width: 89%
table.form-table
  font-weight: normal
  th
    padding: 5px
    text-align: right
    vertical-align: top
  td
    padding: 5px
    width: 340px
    label
      font-weight: normal
</style>



// WEBPACK FOOTER //
// ItemDetail.vue?0432c95b